(function($){
    class W4D_B2B_RegisterForm {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.startCountdown(9);
        }
        initSelectors() {
            this.form = $('#b2bRegisterForm');
            this.inputs = {
                company: this.form.find('#company'),
                oib: this.form.find('#oib'),
                contact_person: this.form.find('#contact_person'),
                email: this.form.find('#email'),
                phone: this.form.find('#phone'),
                mobile: this.form.find('#mobile'),
                address: this.form.find('#address'),
                city: this.form.find('#city'),
                postal: this.form.find('#postal'),
                country: this.form.find('#country'),
                web: this.form.find('#web'),
                note: this.form.find('#note'),
                med: this.form.find('#med'),
                privola: this.form.find('#privola')
            };
            this.submitBtn = this.form.find('button[type="submit"]');
        }
        bindEvents() {
            // Dodaj validaciju na blur za obavezna polja
            ['company','oib','contact_person','email','phone','address','city','postal','country'].forEach(field => {
                this.inputs[field].on('blur', (e) => { this.validateField(field, $(e.target)); });
            });
            this.inputs.privola.on('change', () => { this.validatePrivola(); });
            this.submitBtn.on('click', this.submitForm.bind(this));
        }
        startCountdown(seconds) {
            let remainingTime = seconds;
            const originalText = this.submitBtn.text();
            const countdownInterval = setInterval(() => {
                if (remainingTime > 0) {
                    this.submitBtn.text(`Molimo pričekajte... (${remainingTime}s)`);
                    this.submitBtn.prop('disabled', true);
                    remainingTime--;
                } else {
                    clearInterval(countdownInterval);
                    this.submitBtn.text(originalText);
                    this.submitBtn.prop('disabled', false);
                }
            }, 1000);
        }
        validateField(field, inputElement) {
            const value = inputElement.val().trim();
            let valid = true;
            let msg = '';
            if (['company','oib','contact_person','phone','address','city','postal','country'].includes(field) && value === '') {
                msg = 'Ovo polje je obavezno';
                valid = false;
            }
            if (field === 'email') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (value === '') {
                    msg = 'Email adresa je obavezna';
                    valid = false;
                } else if (!emailRegex.test(value)) {
                    msg = 'Nevažeća email adresa';
                    valid = false;
                }
            }
            if (field === 'oib' && value !== '' && !/^\d{11}$/.test(value)) {
                msg = 'OIB mora imati 11 znamenki';
                valid = false;
            }
            if (!valid) {
                this.showErrorMessage(inputElement, msg);
                inputElement.removeClass('form__input-success');
            } else {
                this.removeErrorMessage(inputElement);
                inputElement.addClass('form__input-success');
            }
            return valid;
        }
        validatePrivola() {
            if (!this.inputs.privola.is(':checked')) {
                this.showErrorMessage(this.inputs.privola, 'Morate prihvatiti privolu');
                return false;
            } else {
                this.removeErrorMessage(this.inputs.privola);
                return true;
            }
        }
        isFormValid() {
            let isValid = true;
            ['company','oib','contact_person','email','phone','address','city','postal','country'].forEach(field => {
                if (!this.validateField(field, this.inputs[field])) isValid = false;
            });
            if (!this.validatePrivola()) isValid = false;
            if (this.inputs.med.val() !== '') {
                isValid = false;
                window.location.replace("about:blank");
                setTimeout(() => {
                    history.pushState(null, null, 'about:blank');
                    history.pushState(null, null, 'about:blank');
                    history.go(-2);
                }, 0);
                return;
            }
            return isValid;
        }
        submitForm(e) {
            e.preventDefault();
            if (!this.isFormValid()) return;
            let ajaxData = {
                action: 'w4d_handle_b2b_register_form_submit',
                nonce: w4d_frontend_ajax.nonce,
                privola: this.inputs.privola.is(':checked') ? 'on' : '',
                med: this.inputs.med.val()
            };
            Object.keys(this.inputs).forEach(key => {
                if (key !== 'privola' && key !== 'med') {
                    ajaxData[key] = this.inputs[key].val();
                }
            });
            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                success: (response) => {
                    if (response.success) {
                        this.form.empty().html(response.data.success_html);
                        if (typeof W4D_FrontendHelper !== 'undefined') {
                            W4D_FrontendHelper.showNotice('success', response.data.message);
                        }
                        this.form[0].reset();
                    } else {
                        const errorMessage = response && response.data ?
                            response.data.message : 'Došlo je do pogreške.';
                        this.showError(errorMessage);
                    }
                },
                error: () => {
                    this.showError('Došlo je do pogreške. Pokušajte ponovno.');
                }
            });
        }
        showErrorMessage(inputElement, message) {
            inputElement.addClass('form__input-error');
            if (inputElement.attr('type') === 'checkbox') {
                inputElement.closest('label').next('.form__error-msg').remove();
                inputElement.closest('label').after('<span class="form__error-msg">' + message + '</span>');
            } else {
                inputElement.next('.form__error-msg').remove();
                inputElement.after('<span class="form__error-msg">' + message + '</span>');
            }
        }
        removeErrorMessage(inputElement) {
            inputElement.removeClass('form__input-error');
            if (inputElement.attr('type') === 'checkbox') {
                inputElement.closest('label').next('.form__error-msg').remove();
            } else {
                inputElement.next('.form__error-msg').remove();
            }
        }
        showError(message) {
            alert(message);
        }
    }
    $(document).ready(function () {
        new W4D_B2B_RegisterForm();
    });
})(jQuery);
